import {connect} from 'react-redux';
import { formValueSelector } from 'redux-form';
import SquadForm from './SquadForm.jsx';

import {
  validate,
  handleSave,
  confirmSquadDelete
} from './actions';

import {hideSquadDialog} from './actionTypes';

const selector = formValueSelector('tournamentSquadForm');

const mapStateToProps = state => ({
  validate: validate,
  canRepeat: selector(state, 'canRepeat'),
  canDelete: selector(state, 'canDelete'),
  tmsEndpoint: selector(state, 'tmsEndpoint'),
  status: selector(state, 'status'),
  minDateUntil: selector(state, 'minDateUntil'),
  eventTypes: state.tournament.squads.eventTypes,
  timeZoneDisplay: selector(state, 'timeZoneDisplayName')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSave(data)),
  confirmDelete: () => dispatch(confirmSquadDelete()),
  onCancel: () => dispatch(hideSquadDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(SquadForm);



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadFormContainer.jsx